import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';
import {HttpModule} from '@angular/http';
import {FormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {NotificationsService, SimpleNotificationsModule} from 'angular2-notifications';
import {BulkInfohashV2ManageComponent} from './bulk-infohash-v2-manage/bulk-infohash-v2-manage.component';
import {BulkInfohashV2ManageService} from './bulk-infohash-v2-manage/bulk-infohash-v2-manage.service';
import {BootstrapModalModule} from 'ngx-modialog/plugins/bootstrap';
import {Ng2CompleterModule} from 'ng2-completer';
import {BsDatepickerModule, TooltipModule} from 'ngx-bootstrap';
import {BulkInfohashV2TitlesComponent} from './bulk-infohash-v2-search/bulk-infohash-v2-titles.component';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {BulkInfohashV2TitlesService} from './bulk-infohash-v2-search/bulk-infohash-v2-titles.service';
import {ChartsModule} from 'ng2-charts';
import {InfohashService} from '../catalogue/infohash/infohash.service';
import {ImageUpdateService} from '../catalogue/image-update/image-update.service';
import {BulkInfohashV2ResultsComponent} from './bulk-infohash-v2-results/bulk-infohash-v2-results.component';
import {QAService} from '../catalogue/qa/qa.service';
import {TitleRequestsService} from '../catalogue/title-requests/title-requests.service';
import {SchedulingService} from '../catalogue/scheduling/scheduling.service';
import {DiscoveryService} from '../catalogue/discovery/discovery.service';
import {DatePipe} from '@angular/common';
import {ClipboardService} from 'ngx-clipboard';
import {BulkInfohashV2BusyIndicatorComponent} from './bulk-infohash-v2-loading/bulk-infohash-v2-busy-indicator.component';
import {CatalogModule} from '../catalogue/catalog.module';
import {BulkInfohashV2SmartResultsComponent} from './bulk-infohash-v2-smart-results/bulk-infohash-v2-smart-results.component';


@NgModule({
    declarations: [
        BulkInfohashV2TitlesComponent, BulkInfohashV2ManageComponent, BulkInfohashV2BusyIndicatorComponent,
        BulkInfohashV2ResultsComponent, BulkInfohashV2SmartResultsComponent],
    exports: [BulkInfohashV2TitlesComponent],
    imports: [BrowserModule,
        HttpModule,
        FormsModule,
        SharedModule,
        SimpleNotificationsModule.forRoot(),
        BootstrapModalModule,
        Ng2CompleterModule,
        BsDatepickerModule.forRoot(),
        CollapseModule.forRoot(),
        TooltipModule.forRoot(), ChartsModule, CatalogModule],
    providers: [
        BulkInfohashV2ManageService, DatePipe, NotificationsService,
        ClipboardService,
        InfohashService,
        ImageUpdateService,
        BulkInfohashV2TitlesService,
        QAService, TitleRequestsService,
        SchedulingService,
        DiscoveryService]
})
export class BulkInfohashV2Module {
}



// WEBPACK FOOTER //
// ./src/app/bulkinfohash-v2/bulk-infohash-v2.module.ts